<template>
  <div class="vue-step-wizard">
    <div class="step-header">
      <div class="step-progress">
        <div class="bar progressbar" :style="{ width: progress + '%' }"></div>
      </div>
      <ul class="step-pills">
        <li
          @click.prevent.stop="selectTab(index)"
          class="step-item"
          :class="{ active: tab.isActive, validated: tab.isValidated }"
          v-for="(tab, index) in tabs"
          v-bind:key="`tab-${index}`"
        >
          <a class="step-link" href="#">
            <span class="tabStatus">{{ index + 1 }} </span>
            <span class="tabLabel">{{ tab.title }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="step-body">
      <form>
        <slot></slot>
      </form>
    </div>
    <div class="step-footer">
      <div class="btn-group" role="group">
        <template v-if="!submitSuccess">
          <button
            @click="previousTab"
            class="step-button step-button-previous"
          >
            Revenir
          </button>
          <button
            @click="nextTab"
            v-if="currentTab < totalTabs - 1"
            class="step-button step-button-next"
          >
            Continuer
          </button>
          <button
            @click="onSubmit"
            v-if="currentTab === totalTabs - 1"
            class="step-button step-button-submit"
          >
            Demander
          </button>
        </template>
        <template v-else>
          <button @click="reset" class="step-button step-button-reset">
            Reset
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { store } from "./store.js";
export default {
  name: "form-wizard",
  data() {
    return {
      tabs: [],
      currentTab: 0,
      totalTabs: 0,
      storeState: store.state,
      submitSuccess: false,
      progress: 0,
      isValidationSupport: false,
    };
  },
  mounted() {
    this.tabs = this.$children;
    this.totalTabs = this.tabs.length;
    this.currentTab = this.tabs.findIndex((tab) => tab.isActive === true);

    //Select first tab if none is marked selected
    if (this.currentTab === -1 && this.totalTabs > 0) {
      this.tabs[0].isActive = true;
      this.currentTab = 0;
    }

    //Setup Initial Progress
    this.progress = ((this.currentTab + 1) / this.totalTabs) * 100;
  },

  updated() {
    /*
          Using this lifehook - since store variable gets updated after component is mounted
          isValidationSupport checks if user is looking to perform validation on each step
        */
    this.isValidationSupport =
      Object.keys(this.storeState.v).length !== 0 &&
      this.storeState.v.constructor === Object
        ? true
        : false;
  },

  methods: {

    fixScroll() {
      var element = document.querySelector(".otherFormquote");

      element.scrollIntoView();
    },
    previousTab() {

      if (this.currentTab == 0){
        document.getElementById("memem121212").click();
      } else {
        this._switchTab(this.currentTab - 1);
        this.$emit("onPreviousStep");
      }

      this.fixScroll();
    },

    nextTab() {
      let thisTab = this.currentTab + 1;
      document.getElementById("validation" + thisTab).click();
      if (
        document
          .getElementById("validation" + thisTab)
          .getAttribute("validation") == "validated"
      ) {
        this._switchTab(this.currentTab + 1);

        this.$emit("onNextStep");

        this.fixScroll();
      }
    },

    reset() {
      this.tabs.forEach((tab) => {
        tab.isActive = false;
        tab.isValidated = false;
      });

      this._switchTab(0);
      this.submitSuccess = false;
      this.storeState.v.$reset();

      this.$emit("onReset");
    },

    changeStatus() {
      this.submitSuccess = true;
    },

    selectTab(index) {
      //Only switch to filled previous tabs
      if (index < this.currentTab) {
        this._switchTab(index);
        return;
      }

      if (this._validateCurrentTab() === false) {
        return;
      }

      if (this.tabs[index - 1].isValidated === false) {
        return;
      }

      this._switchTab(index);
    },

    onSubmit() {
      let thisTab = this.currentTab + 1;
      document.getElementById("validation" + thisTab).click();

      if (
        document
          .getElementById("validation" + thisTab)
          .getAttribute("validation") == "validated"
      ) {
        this.$emit("onComplete");
      }
    },

    _switchTab(index) {
      //Disable all tabs
      this.tabs.forEach((tab) => {
        tab.isActive = false;
      });

      this.currentTab = index;
      this.tabs[index].isActive = true;

      this.progress = ((this.currentTab + 1) / this.totalTabs) * 100;
    },

    _validateCurrentTab() {
      if (!this.isValidationSupport)
        //Check if user wants to validate
        return true;

      this.storeState.v.$touch();

      if (this.storeState.v.$invalid) {
        this.tabs[this.currentTab].isValidated = false;
        return false;
      }

      this.tabs[this.currentTab].isValidated = true;

      return true;
    },
  },
  watch: {
    currentTab() {
      store.setCurrentTab(this.currentTab);
    },
  },
};
</script>